import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Login = ({ setIsAuthenticated }) => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [isShaking, setIsShaking] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const navigate = useNavigate();

  const logoPath = process.env.PUBLIC_URL + '/favi1.jpg';

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogin = (e) => {
    e.preventDefault();
    if (credentials.username === 'admin' && credentials.password === '12345') {
      setIsAuthenticated(true);
      localStorage.setItem('isAuth', 'true');
      navigate('/admin');
    } else {
      setError('தவறான விவரங்கள்!');
      setIsShaking(true);
      setTimeout(() => setIsShaking(false), 500);
    }
  };

  return (
    <div style={containerStyle}>
      {/* --- INLINE CSS FOR ANIMATIONS --- */}
      <style>
        {`
          @keyframes float {
            0% { transform: translateY(0px); }
            50% { transform: translateY(-20px); }
            100% { transform: translateY(0px); }
          }
          @keyframes shake {
            0%, 100% { transform: translateX(0); }
            25% { transform: translateX(-10px); }
            75% { transform: translateX(10px); }
          }
          .animate-float { animation: float 6s ease-in-out infinite; }
          .animate-shake { animation: shake 0.4s ease-in-out; }
          .glass-card {
            background: rgba(255, 255, 255, 0.9);
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255, 255, 255, 0.2);
          }
        `}
      </style>

      {/* --- FULL WIDTH TOP NAV --- */}
      <nav style={{ 
        width: '100%', 
        background: '#fff', 
        padding: isMobile ? '10px 20px' : '15px 60px', 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
        zIndex: 100
      }}>
        <img src={logoPath} alt="Logo" style={{ height: isMobile ? '35px' : '50px' }} />
        <span style={{ color: '#e91e63', fontWeight: 'bold', fontSize: isMobile ? '12px' : '16px' }}>
          ADMIN PORTAL
        </span>
      </nav>

      {/* --- MAIN SECTION WITH OVERLAP --- */}
      <div style={{ flex: 1, position: 'relative', display: 'flex', justifyContent: 'center', padding: '0 20px' }}>
        
        {/* Background Decorative Circle */}
        <div style={circleDecorStyle}></div>

        <div className={`glass-card animate-float ${isShaking ? 'animate-shake' : ''}`} style={{
          marginTop: isMobile ? '40px' : '60px',
          width: '100%',
          maxWidth: '400px',
          height: 'fit-content',
          padding: isMobile ? '30px 20px' : '40px',
          borderRadius: '24px',
          boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
          textAlign: 'center',
          zIndex: 2
        }}>
          <h2 style={{ color: '#333', marginBottom: '8px' }}>நிர்வாகி உள்நுழைவு</h2>
          <p style={{ color: '#666', fontSize: '14px', marginBottom: '30px' }}>Please login to continue</p>

          <form onSubmit={handleLogin}>
            <div style={{ textAlign: 'left', marginBottom: '20px' }}>
              <label style={labelStyle}>USERNAME</label>
              <input 
                type="text" 
                style={inputStyle} 
                placeholder="Enter Username"
                onChange={(e) => setCredentials({...credentials, username: e.target.value})}
              />
            </div>

            <div style={{ textAlign: 'left', marginBottom: '30px' }}>
              <label style={labelStyle}>PASSWORD</label>
              <input 
                type="password" 
                style={inputStyle} 
                placeholder="Enter Password"
                onChange={(e) => setCredentials({...credentials, password: e.target.value})}
              />
            </div>

            {error && <p style={{ color: 'red', fontSize: '12px', marginBottom: '15px' }}>{error}</p>}

            <button type="submit" style={btnStyle}>SIGN IN</button>
          </form>
        </div>
      </div>

      {/* --- FOOTER --- */}
     
    </div>
  );
};

// --- STYLES ---
const containerStyle = {
  minHeight: '100vh',
  background: 'linear-gradient(135deg, #fce4ec 0%, #f8f9fa 100%)',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden'
};

const circleDecorStyle = {
  position: 'absolute',
  top: '10%',
  right: '15%',
  width: '300px',
  height: '300px',
  background: 'linear-gradient(to right, #ffafbd, #ffc3a0)',
  borderRadius: '50%',
  filter: 'blur(80px)',
  opacity: 0.5,
  zIndex: 1
};

const labelStyle = {
  fontSize: '11px',
  fontWeight: 'bold',
  color: '#e91e63',
  marginLeft: '5px'
};

const inputStyle = {
  width: '100%',
  padding: '15px',
  marginTop: '5px',
  border: '1px solid #eee',
  borderRadius: '12px',
  outline: 'none',
  fontSize: '14px',
  boxSizing: 'border-box',
  transition: '0.3s'
};

const btnStyle = {
  width: '100%',
  padding: '15px',
  background: '#e91e63',
  color: '#fff',
  border: 'none',
  borderRadius: '12px',
  fontWeight: 'bold',
  cursor: 'pointer',
  boxShadow: '0 10px 20px rgba(233, 30, 99, 0.2)',
};

const footerStyle = {
  padding: '30px',
  background: '#fff',
  textAlign: 'center',
  color: '#666',
  fontSize: '14px',
  boxShadow: '0 -4px 20px rgba(0,0,0,0.05)'
};

export default Login;